import { MapDataService } from '@ui/shared/domain-map';
import { map, type Observable, of } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { SportAtlasService } from '@ui/shared/util-api';
import { toRequestQuery } from '@ui/shared/util-filter';
import { SportMapItem } from '../../definitions/sport-map-item';
import type { SportMapFilter } from '../../types/sport-map-filter';
import { TypeFilterOptions } from '../../definitions/filter-option-keys';

@Injectable({ providedIn: 'root' })
export class PublicSportsFacilityMapDataService extends MapDataService<SportMapItem, SportMapFilter> {
    protected _api = inject(SportAtlasService);

    public getData$(filter: SportMapFilter): Observable<Array<SportMapItem>> {
        const typeId = toRequestQuery(filter.types)[0];
        const targetGroup = toRequestQuery(filter.targetGroup);

        if ((typeId && ![TypeFilterOptions.PublicSportFacility, TypeFilterOptions.All].includes(typeId)) || targetGroup.length) {
            return of([]);
        }

        return this._api.getAllPublicSportsFacilities({
            sportsIds: toRequestQuery(filter.sports),
            accessibilityFeatureIds: toRequestQuery(filter.accessibilityFeatures),
            order: [],
            search: typeof filter.search === 'string' ? filter.search : null,
        })
            .pipe(map(response => response.data.map(dto => new SportMapItem({
                publicSportsFacility: dto,
                linkedItems: [],
            }))));
    }
}
